import find from 'lodash/find';
import cardTypes from './cardTypes';

export const RECAPTCHASITEKEY = '6LfV4twUAAAAAD7kmX0aTCT2um_RbufGYlLcqVUz';

export const enableCVV = (type, collectCVVConfigs, isCVVAvailable) => {
  const findObject = find(collectCVVConfigs, [ 'cardType', type ]);
  return (findObject
    ? findObject.collectCVV
    : isCVVAvailable)
    && cardTypes[type].enableCVV;
};

export const executeCaptcha = (callback, datas, successCallbackParams, committerCallback) => {
  if (!window.grecaptcha) {
    committerCallback({ errorCode: 'NO_GRECAPTCHA_OBJECT' });
    return;
  }
  window.grecaptcha.ready(() => {
    window.grecaptcha.execute(RECAPTCHASITEKEY, {
      action: 'pci_iframe_form',
    }).then((token) => {
      const params = { ...datas, GRecaptchaToken: token };
      callback({ params, successCallbackParams });
    });
  });
};

export const filterNumbers = value => value && value.replace(/\D/g, '');

export const getByPath = (obj, path) => path.split('.').reduce((acc, k) => (acc ? acc[k] : acc), obj || {});

/**
 * This builder will build the proxy triggers for each of the child
 * convert those data: ['newCard', 'savedCard'], orgionTriggers
 * to: { newCardTriggers: { ...proxyTriggers }, savedCardTriggers: { ...proxyTriggers } }
 */
export const buildChildrenTriggers = (children, triggers, getCurrentChild) => {
  const triggerNames = Object.keys(triggers);
  const triggerMappings = {};

  // Return the proxy triggers
  const buildProxyTrigger = triggerName => (...args) => triggerMappings[
    getCurrentChild()
  ][triggerName].apply(null, args);
  triggerNames.forEach(triggerName => triggers[triggerName](buildProxyTrigger(triggerName)));

  // Build children triggers
  const setTrigger = (trigger, child, triggerName) => {
    // Set the child component trigger to the map, and then the proxy trigger can use it.
    (triggerMappings[child] = triggerMappings[child] || {})[triggerName] = trigger;
  };
  const buildChildTriggers = child => triggerNames.reduce(
    (childTriggers, triggerName) => Object.assign(childTriggers, {
      [triggerName]: (trigger) => {
        setTrigger(trigger, child, triggerName);
      },
    }),
    {},
  );
  return children.reduce(
    (childrenTriggers, child) => Object.assign(childrenTriggers, { [`${child}Triggers`]: buildChildTriggers(child) }),
    {},
  );
};

export const appendScript = (url, onReadyCallback, async, container, onErrorCallback) => {
  const targetScript = document.createElement('script');
  targetScript.type = 'text/javascript';
  targetScript.async = async || async === undefined;
  targetScript.onload = () => {
    onReadyCallback && onReadyCallback();
  };
  targetScript.onerror = () => {
    onErrorCallback && onErrorCallback('error');
  };

  targetScript.src = url;
  if (container === 'head') {
    document.head.appendChild(targetScript);
  } else {
    document.body.appendChild(targetScript);
  }
};